import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { TID } from "@/constants/testIds";
import { Lightning } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1559619081-8fd2cc754ca3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/dashboard" : "/");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative h-full flex flex-col justify-end p-12">
          <Lightning size={40} weight="fill" color="#FF007F" />
          <h2 className="font-display text-4xl font-black uppercase mt-4 leading-tight">Welcome back to<br />the bazaar</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <h1 className="font-display text-3xl font-black uppercase mb-1">Log In</h1>
          <p className="text-zinc-400 text-sm mb-6">Access your deals and dashboard.</p>
          {err && <p className="text-[#FF007F] text-sm mb-4 border border-[#FF007F] p-2" data-testid="login-error">{err}</p>}
          <label className="text-xs uppercase tracking-widest text-zinc-400">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid={TID.loginEmail}
            className="w-full mt-1 mb-4 bg-zinc-900 border border-zinc-700 focus:border-[#00FFFF] outline-none px-3 py-3 text-white" />
          <label className="text-xs uppercase tracking-widest text-zinc-400">Password</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid={TID.loginPassword}
            className="w-full mt-1 mb-6 bg-zinc-900 border border-zinc-700 focus:border-[#00FFFF] outline-none px-3 py-3 text-white" />
          <button type="submit" disabled={busy} data-testid={TID.loginSubmit}
            className="w-full py-3 bg-[#FF007F] text-white font-black uppercase tracking-widest border border-[#FF007F] hover:bg-[#09090B] hover:text-[#FF007F] transition-colors disabled:opacity-50">
            {busy ? "Logging in…" : "Log In"}
          </button>
          <p className="text-sm text-zinc-500 mt-4"><Link to="/forgot-password" className="text-[#00FFFF] underline" data-testid="login-forgot-link">Forgot your password?</Link></p>
          <p className="text-sm text-zinc-400 mt-1">No account? <Link to="/register" className="text-[#00FFFF] underline">Join now</Link></p>
        </form>
      </div>
    </div>
  );
}
